import SelectedStarIcon from '@modules/organizations/assets/icons/SelectedStarIcon.svg';
import User from '@modules/shared/components/Icons/User';

import { Col, Row, Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const BoxMainRow = styled(Row)`
  & {
    align-items: center; 
    row-gap: 0px;
    cursor: pointer;
    border-top: solid 0.5px rgba(0, 0, 0, 0.25);
    padding-top: 8px;
    padding-bottom: 8px;
    margin-left: 8px;

    &:hover {
      background: rgba(0, 204, 204, 0.15);
    };
  }
`;

export const TitleText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  &:hover {
    text-decoration: underline;
  }
`;

export const RoleText = styled(Text)`
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 400;
`;

export const IdText = styled(Text)`
  & {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    margin-right: 4px;

    &:hover span {
      visibility: visible;
    } 
  }
`;

export const UserIconStyled = styled(User)`
  width: 14px;
  position: relative;
  top: 2px;
  height: 16px;
  color: rgba(0, 0, 0, 0.45);
  margin-right: 10px;
`;

export const SelectedStarIconStyled = styled(SelectedStarIcon)`
  position: relative;
  top: 3px;
  margin-left: 8px;
`;

export const IconWrapper = styled.span`
  visibility: hidden;
  display: inline-block;
  margin-left: 8px;

  /* Ensure the icon is properly aligned */
  svg {
    cursor: pointer;
  }
`;

export const SelectCol = styled(Col)`
  text-align: center; 
  margin-right: 10px;
  @media (max-width: 576px) {
    display: none;
  }
`;
